import * as React from 'react'
import Link from 'next/link'
import { useTranslations } from 'next-intl'

import InnerLogo from './InnerLogo'

type Props = {
  login?: boolean
  registration?: boolean
}

export default function AuthHeader(props: Props) {
  const t = useTranslations()
  return (
    <div className="flex items-center justify-center py-[18px] lg:justify-between lg:pt-[13px] lg:pb-[48px]">
      <Link href="/" className="relative no-underline text-primary">
        <InnerLogo svgClassName="w-[85px] h-auto lg:w-[135px] lg:h-[38px]" />
      </Link>

      <nav className="hidden lg:flex items-center space-x-[33px]">
        <Link
          href="/"
          className={`py-[21px] text-[14px] font-bold leading-[16px] uppercase no-underline ${
            props.login ? 'text-primary' : 'text-input-label'
          }`}
        >
          {t('authHeader.login')}
        </Link>
        <Link
          href="/registration"
          className={`py-[21px] text-[14px] font-bold leading-[16px] uppercase no-underline ${
            props.registration ? 'text-primary' : 'text-input-label'
          }`}
        >
          {t('authHeader.registration')}
        </Link>
      </nav>
    </div>
  )
}
